import React from "react";
import Quiz from "../Quiz";

const questions = [
  // Vocabulary & Parts of Speech
  {
    questionText: "Which word is an abstract noun?",
    options: ["Table", "Freedom", "Student", "Teacher"],
    correct: "Freedom",
  },
  {
    questionText: "Which of the following is an adjective?",
    options: ["Quickly", "Happiness", "Bright", "Swim"],
    correct: "Bright",
  },
  {
    questionText: "Choose the correct synonym for 'reluctant':",
    options: ["Willing", "Unwilling", "Happy", "Energetic"],
    correct: "Unwilling",
  },

  // Grammar (Intermediate)
  {
    questionText: "The homework __________ by the time the teacher arrives.",
    options: ["is done", "was done", "will have been done", "has done"],
    correct: "will have been done",
  },
  {
    questionText: "If I had studied harder, I __________ the test.",
    options: ["pass", "passed", "would have passed", "would pass"],
    correct: "would have passed",
  },
  {
    questionText: "Which sentence uses the passive voice?",
    options: [
      "The dog chased the cat.",
      "They will finish the project soon.",
      "The cake was eaten by the children.",
      "I clean my room every Saturday.",
    ],
    correct: "The cake was eaten by the children.",
  },
  {
    questionText: "Choose the correct form: Neither the students nor the teacher __________ in the classroom.",
    options: ["are", "is", "were", "being"],
    correct: "is",
  },

  // Comprehension (based on an implied passage)
  {
    questionText: "The author believes technology is helpful because it:",
    options: [
      "Replaces human thinking",
      "Makes life more difficult",
      "Improves learning and communication",
      "Stops people from talking",
    ],
    correct: "Improves learning and communication",
  },
  {
    questionText: "What is the author's tone in the article?",
    options: ["Angry", "Excited", "Informative", "Confused"],
    correct: "Informative",
  },
  {
    questionText: "What is the main idea of the passage?",
    options: [
      "Technology is dangerous",
      "We should ban social media",
      "Technology can be used for good when managed wisely",
      "People should use only books to learn",
    ],
    correct: "Technology can be used for good when managed wisely",
  },

  // Sentence correction & structure
  {
    questionText: "Which sentence is punctuated correctly?",
    options: [
      "Maria who lives next door is my friend.",
      "Maria, who lives next door, is my friend.",
      "Maria who lives next door, is my friend.",
      "Maria who, lives next door is my friend.",
    ],
    correct: "Maria, who lives next door, is my friend.",
  },
  {
    questionText: "Which sentence is written in formal English?",
    options: [
      "She gonna do her work later.",
      "She's doing her work now.",
      "She's gonna be doing her work.",
      "She is going to complete her work later.",
    ],
    correct: "She is going to complete her work later.",
  },

  // Conditional logic
  {
    questionText: "If it rains tomorrow, we __________ the trip.",
    options: ["cancel", "will cancel", "would cancel", "cancelled"],
    correct: "will cancel",
  },

  // Word usage
  {
    questionText: "Choose the best word: He gave a very __________ speech that inspired everyone.",
    options: ["inspiring", "inspired", "inspires", "inspire"],
    correct: "inspiring",
  },
  {
    questionText: "Choose the correct word: She spoke so __________ that the entire hall was silent.",
    options: ["power", "powerfully", "powerful", "powered"],
    correct: "powerfully",
  },

  // Sentence transformation
  {
    questionText: "Change to reported speech: She said, 'I am reading a book.'",
    options: [
      "She said she is reading a book.",
      "She said she was reading a book.",
      "She said I was reading a book.",
      "She said that she reads a book.",
    ],
    correct: "She said she was reading a book.",
  },
  {
    questionText: "What is the correct indirect version: John asked, 'Did you finish the homework?'",
    options: [
      "John asked if I had finished the homework.",
      "John asked if I finish the homework.",
      "John asked if I have finished the homework.",
      "John asked did I finish the homework.",
    ],
    correct: "John asked if I had finished the homework.",
  },

  // Homophones
  {
    questionText: "Choose the correct word: The __________ of the book was very interesting.",
    options: ["tail", "tale"],
    correct: "tale",
  },
  {
    questionText: "Choose the correct word: Please __________ the gift with care.",
    options: ["wrap", "rap"],
    correct: "wrap",
  },

  // Prefixes and suffixes
  {
    questionText: "What does the prefix 'un-' in 'unhappy' mean?",
    options: ["Very", "Again", "Not", "Before"],
    correct: "Not",
  },
  {
    questionText: "What does the suffix '-ness' in 'kindness' mean?",
    options: ["The opposite of", "The action of", "The state of", "To do something"],
    correct: "The state of",
  },
];

export default function EnglishQuiz8({ studentInfo, onComplete }) {
  return <Quiz studentInfo={studentInfo} questions={questions} onComplete={onComplete} />;
}
